import client from './client';
import { createCategoryApi } from './categories';

const PATH = '/api/gallery/images/';

const list = (params = {}) => {
  const { url, ...rest } = params;
  if (url) return client.get(url).then((r) => r.data);
  return client.get(PATH, { params: rest }).then((r) => r.data);
};
const detail = (slug) => client.get(`${PATH}${slug}/`).then((r) => r.data);

/** Build a multipart FormData payload for gallery image create/update. */
const toFormData = ({ title, caption, category, image, is_featured, is_active }) => {
  const fd = new FormData();
  if (title !== undefined) fd.append('title', title);
  if (caption !== undefined) fd.append('caption', caption);
  if (category !== undefined && category !== null && category !== '') fd.append('category', category);
  if (image instanceof File) fd.append('image', image, image.name);
  if (is_featured !== undefined) fd.append('is_featured', is_featured ? 'true' : 'false');
  if (is_active !== undefined) fd.append('is_active', is_active ? 'true' : 'false');
  return fd;
};

/** Build a multipart payload for bulk gallery upload (multiple images). */
const toBulkFormData = ({ images, category, caption, is_featured, is_active }) => {
  const fd = new FormData();
  (images || []).forEach((file) => fd.append('images', file, file.name));
  if (category !== undefined && category !== null && category !== '') fd.append('category', category);
  if (caption !== undefined) fd.append('caption', caption);
  if (is_featured !== undefined) fd.append('is_featured', is_featured ? 'true' : 'false');
  if (is_active !== undefined) fd.append('is_active', is_active ? 'true' : 'false');
  return fd;
};

export const galleryApi = {
  list,
  detail,

  create(payload, { onUploadProgress } = {}) {
    return client.post(PATH, toFormData(payload), { timeout: 0, onUploadProgress }).then((r) => r.data);
  },

  update(slug, payload, { onUploadProgress } = {}) {
    return client.patch(`${PATH}${slug}/`, toFormData(payload), { timeout: 0, onUploadProgress }).then((r) => r.data);
  },

  bulk(payload, { onUploadProgress } = {}) {
    return client.post(`${PATH}bulk/`, toBulkFormData(payload), { timeout: 0, onUploadProgress }).then((r) => r.data);
  },

  remove(slug) {
    return client.delete(`${PATH}${slug}/`).then((r) => r.data);
  },

  publish(slug) {
    return client.post(`${PATH}${slug}/publish/`).then((r) => r.data);
  },

  unpublish(slug) {
    return client.post(`${PATH}${slug}/unpublish/`).then((r) => r.data);
  },

  categories: createCategoryApi('gallery'),
};
